package com.example.mystybag.common.views

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.core.model.LinkModel
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.model.ChooseTakePhotoOrPickFileVisualModel
import com.example.mystybag.common.model.IconData
import com.example.mystybag.common.ui.components.custom.OneLineTextIconClickableView
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.views.ActionSheetHeader

@Composable
fun ChooseTakePhotoOrPickFileBottomSheetView(
    title                   : String,
    infoText                : List<LinkModel>?,
    onInfoButtonClicked     : () -> Unit,
    additionalRows          : List<ChooseTakePhotoOrPickFileVisualModel>?
) {
    Column(modifier = Modifier.fillMaxWidth().background(AppTheme.current.colors.surface)) {
        ActionSheetHeader(title = title.ifBlank { null })

        infoText?.let {
            Texts.ClickableTextView(
                modifier        = Modifier
                    .fillMaxWidth()
                    .padding(start = p32, end = p32, top = p12),
                textStyle       = AppTheme.current.typography.labelLarge,
                textAlign       = TextAlign.Center,
                texts           = it,
                mainTextColor   = AppTheme.current.colors.onSurfaceVariant,
                onItemClick     = {
                    onInfoButtonClicked()
                }
            )
        }

        additionalRows?.forEach { item ->
            OneLineTextIconClickableView(
                modifier    = Modifier.padding(all = p4),
                text        = item.text,
                iconModel   = IconData(icon = painterResource(item.image)),
                doOnClick   = item.onClick
            )
        }
    }
}